import { Theme } from '@/components/Block'
import GsuLoader from '@/components/GsuLoader'
import { UnitSize } from '@/constants/measured-scope'
import { SectionNavigationAction } from '@/shared/api-generated-types'
import CardRow from '@/widgets/v2/CardRow'
import ArticleCard, { Props as ArticleCardProps } from '@/widgets/v2/ArticleCard'

type CarouselOptions = false | UnitSize[] | 'always'

export interface ArticleCardRowProps {
  title?: string | null
  subtitle?: string | null
  theme?: Theme
  carousel?: CarouselOptions
  items: Partial<ArticleCardProps>[]
  className?: string
  navigationActions?: SectionNavigationAction[]
  fetching?: boolean
}
export type DeviceSizes = {
  [key in UnitSize]: boolean | undefined
}

const ArticleCardRow = ({
  title,
  subtitle,
  theme = 'white',
  navigationActions,
  items,
  className = '',
  fetching,
}: ArticleCardRowProps): JSX.Element => {
  if (fetching) return <GsuLoader consumeSpace />

  const articleCards = items
    ? items.map((item) => {
        return <ArticleCard {...(item as ArticleCardProps)} key={`article_${item.id}`} />
      })
    : []

  return (
    <CardRow
      title={title}
      subtitle={subtitle}
      theme={theme}
      navigationActions={navigationActions}
      className={className}
    >
      {articleCards}
    </CardRow>
  )
}

export default ArticleCardRow
